import React from 'react';
export const WideRightArrow = (props) => {
    return (React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "45", height: "14", viewBox: "0 0 45 14", fill: "none", stroke: "currentColor", ...props },
        React.createElement("path", { d: "M0.625977 6.94474H44.0001M44.0001 6.94474L38.2335 0.458252M44.0001 6.94474L38.2335 13.4312", stroke: "currentColor" })));
};
